import styled from "styled-components";
import { color } from "../../styles";

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80vw;
  width: 70vw;
  min-width: 500px;
  height: 85vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Noto Sans;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: ${color.secondary.CHARCOAL};
`;

export const HeaderActions = styled.div`
  margin-left: auto;
`;

export const Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  background: #fff;
`;

export const ContentContainer = styled.div`
  padding: 24px;
  min-height: 0;
`;

export const LoaderWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding: 24px;
  border-top: 1px solid #eee;
  flex-shrink: 0;
  background: #fff;
  z-index: 1;
`;

export const Footer = styled.div`
  padding: 8px 24px 24px 24px;
  margin-top: auto;
`;


